var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4567_1231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.754 0.220703H13.6491C13.3348 0.220703 13.0801 0.475465 13.0801 0.78973V17.9156C13.0801 18.2299 13.3348 18.4846 13.6491 18.4846H16.754C17.0682 18.4846 17.323 18.2299 17.323 17.9156V0.78973C17.323 0.475465 17.0682 0.220703 16.754 0.220703Z",
    stroke: "black",
    strokeWidth: 0.628216,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4805 4.46484H7.37567C7.0614 4.46484 6.80664 4.71961 6.80664 5.03387V17.9168C6.80664 18.2311 7.0614 18.4859 7.37567 18.4859H10.4805C10.7948 18.4859 11.0496 18.2311 11.0496 17.9168V5.03387C11.0496 4.71961 10.7948 4.46484 10.4805 4.46484Z",
    stroke: "black",
    strokeWidth: 0.628216,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2071 8.70703H1.10223C0.787965 8.70703 0.533203 8.96179 0.533203 9.27606V17.9161C0.533203 18.2304 0.787965 18.4851 1.10223 18.4851H4.2071C4.52136 18.4851 4.77613 18.2304 4.77613 17.9161V9.27606C4.77613 8.96179 4.52136 8.70703 4.2071 8.70703Z",
    stroke: "black",
    strokeWidth: 0.628216,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4567_1231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.247,
    height: 18.7228,
    fill: "white",
    transform: "translate(0.304688 -0.0078125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUc);
export default __webpack_public_path__ + "static/media/UC.e100d60bbffa1a67dc3b8da28c1af5b2.svg";
export { ForwardRef as ReactComponent };